export interface HealthStatusOption {
  value: string;
  label: string;
  dbName?: string;
}

export const HEALTH_STATUS_OPTIONS: HealthStatusOption[] = [
  {
    "value": "TTSK001",
    "label": "Rối loạn chuyển hóa lipid",
    "dbName": "Rối loạn chuyển hóa lipid/ Rối loạn chuyển hóa mỡ máu"
  },
  {
    "value": "TTSK002",
    "label": "Bình thường",
    "dbName": "Bình thường"
  },
  {
    "value": "TTSK003",
    "label": "Béo phì",
    "dbName": "Béo phì"
  },
  {
    "value": "TTSK004",
    "label": "Thừa cân",
    "dbName": "Thừa cân"
  },
  {
    "value": "TTSK005",
    "label": "Thiếu cân",
    "dbName": "Thiếu cân"
  },
  {
    "value": "TTSK006",
    "label": "Tăng huyết áp",
    "dbName": "Tăng huyết áp"
  },
  {
    "value": "TTSK007",
    "label": "Đái tháo đường",
    "dbName": "Đái tháo đường"
  },
  {
    "value": "TTSK008",
    "label": "Gút",
    "dbName": "Gút"
  },
  {
    "value": "TTSK009",
    "label": "Béo phì - Rối loạn chuyển hóa lipit",
    "dbName": "Béo phì - Rối loạn chuyển hóa lipid/ Rối loạn chuyển hóa mỡ máu"
  },
  {
    "value": "TTSK010",
    "label": "Thừa cân - Rối loạn chuyển hóa lipit",
    "dbName": "Thừa cân - Rối loạn chuyển hóa lipid/ Rối loạn chuyển hóa mỡ máu"
  },
  {
    "value": "TTSK011",
    "label": "Thiếu cân - Rối loạn chuyển hóa lipid",
    "dbName": "Thiếu cân - Rối loạn chuyển hóa lipid/ Rối loạn chuyển hóa mỡ máu"
  },
  {
    "value": "TTSK012",
    "label": "Tăng huyết áp - Rối loạn chuyển hóa lipit",
    "dbName": "Tăng huyết áp - Rối loạn chuyển hóa lipid/ Rối loạn chuyển hóa mỡ máu"
  },
  {
    "value": "TTSK013",
    "label": "Béo phì - Tăng huyết áp",
    "dbName": "Béo phì - Tăng huyết áp"
  },
  {
    "value": "TTSK014",
    "label": "Rối loạn chuyển hóa lipid - Đái tháo đường",
    "dbName": "Đái tháo đường - Rối loạn chuyển hóa lipid/ Rối loạn chuyển hóa mỡ máu"
  },
  {
    "value": "TTSK015",
    "label": "Thừa cân - Tăng huyết áp",
    "dbName": "Thừa cân - Tăng huyết áp"
  },
  {
    "value": "TTSK016",
    "label": "Béo phì - Đái tháo đường",
    "dbName": "Béo phì - Đái tháo đường"
  },
  {
    "value": "TTSK017",
    "label": "Béo phì - Tăng huyết áp - Rối loạn chuyển hóa lipit",
    "dbName": "Béo phì - Tăng huyết áp - Rối loạn chuyển hóa lipid/ Rối loạn chuyển hóa mỡ máu"
  },
  {
    "value": "TTSK018",
    "label": "Thừa cân - Tăng huyết áp - Rối loạn chuyển hóa lipit",
    "dbName": "Thừa cân - Tăng huyết áp - Rối loạn chuyển hóa lipid/ Rối loạn chuyển hóa mỡ máu"
  },
  {
    "value": "TTSK019",
    "label": "Béo phì - Rối loạn chuyển hóa lipit - Đái tháo đường",
    "dbName": "Béo phì - Đái tháo đường - Rối loạn chuyển hóa lipid/ Rối loạn chuyển hóa mỡ máu"
  },
  {
    "value": "TTSK020",
    "label": "Thừa cân - Rối loạn chuyển hóa lipit - Đái tháo đường",
    "dbName": "Thừa cân - Đái tháo đường - Rối loạn chuyển hóa lipid/ Rối loạn chuyển hóa mỡ máu"
  },
  {
    "value": "TTSK021",
    "label": "Thiếu cân - Rối loạn chuyển hóa lipit- Đái tháo đường",
    "dbName": "Thiếu cân - Đái tháo đường - Rối loạn chuyển hóa lipid/ Rối loạn chuyển hóa mỡ máu"
  },
  {
    "value": "TTSK022",
    "label": "Béo phì - Tăng huyết áp - Rối loạn chuyển hóa lipit - Đái tháo đường",
    "dbName": "Béo phì - Tăng huyết áp - Đái tháo đường - Rối loạn chuyển hóa lipid/ Rối loạn chuyển hóa mỡ máu"
  },
  {
    "value": "TTSK023",
    "label": "Thừa cân - Tăng huyết áp - Rối loạn chuyển hóa lipit - Đái tháo đường",
    "dbName": "Thừa cân - Tăng huyết áp - Đái tháo đường - Rối loạn chuyển hóa lipid/ Rối loạn chuyển hóa mỡ máu"
  },
  {
    "value": "TTSK024",
    "label": "Thừa cân - Đái tháo đường",
    "dbName": "Thừa cân - Đái tháo đường"
  },
  {
    "value": "TTSK025",
    "label": "Thiếu cân - Tăng huyết áp",
    "dbName": "Thiếu cân - Tăng huyết áp "
  },
  {
    "value": "TTSK026",
    "label": "Thiếu cân - Đái tháo đường",
    "dbName": "Thiếu cân - Đái tháo đường"
  },
  {
    "value": "TTSK027",
    "label": "Tăng huyết áp - Đái tháo đường",
    "dbName": "Tăng huyết áp - Đái tháo đường"
  },
  {
    "value": "TTSK028",
    "label": "Thừa cân - Gút",
    "dbName": "Thừa cân - Gút"
  },
  {
    "value": "TTSK029",
    "label": "Béo phì - Gút",
    "dbName": "Béo phì - Gút"
  },
  {
    "value": "TTSK030",
    "label": "Thiếu cân - Gút",
    "dbName": "Thiếu cân - Gút"
  },
  {
    "value": "TTSK031",
    "label": "Gút - Tăng huyết áp",
    "dbName": "Tăng huyết áp - Gút"
  },
  {
    "value": "TTSK032",
    "label": "Gút - Đái tháo đường",
    "dbName": "Đái tháo đường - Gút"
  },
  {
    "value": "TTSK033",
    "label": "Gút - Rối loạn chuyển hóa lipit",
    "dbName": "Rối loạn chuyển hóa lipid/ Rối loạn chuyển hóa mỡ máu - Gút"
  },
  {
    "value": "TTSK034",
    "label": "Thừa cân - Tăng huyết áp - Đái tháo đường",
    "dbName": "Thừa cân - Tăng huyết áp - Đái tháo đường"
  },
  {
    "value": "TTSK035",
    "label": "Béo phì - Tăng huyết áp - Đái tháo đường",
    "dbName": "Béo phì - Tăng huyết áp - Đái tháo đường"
  },
  {
    "value": "TTSK036",
    "label": "Thiếu cân - Tăng huyết áp - Đái tháo đường",
    "dbName": "Thiếu cân - Tăng huyết áp - Đái tháo đường"
  },
  {
    "value": "TTSK037",
    "label": "Thiếu cân - Tăng huyết áp - Rối loạn chuyển hóa lipit",
    "dbName": "Thiếu cân - Tăng huyết áp - Rối loạn chuyển hóa lipid/ Rối loạn chuyển hóa mỡ máu"
  },
  {
    "value": "TTSK038",
    "label": "Tăng huyết áp - Rối loạn chuyển hóa lipit - Đái tháo đường",
    "dbName": "Tăng huyết áp - Đái tháo đường - Rối loạn chuyển hóa lipid/ Rối loạn chuyển hóa mỡ máu"
  },
  {
    "value": "TTSK039",
    "label": "Thừa cân - Gút - Tăng huyết áp",
    "dbName": "Thừa cân - Gút - Tăng huyết áp"
  },
  {
    "value": "TTSK040",
    "label": "Thừa cân - Gút - Đái tháo đường",
    "dbName": "Thừa cân - Gút - Đái tháo đường"
  },
  {
    "value": "TTSK041",
    "label": "Thừa cân - Gút - Rối loạn chuyển hóa",
    "dbName": "Thừa cân - Gút - Rối loạn chuyển hóa lipid/ Rối loạn chuyển hóa mỡ máu"
  },
  {
    "value": "TTSK042",
    "label": "Béo phì - Gút- Tăng huyết áp",
    "dbName": "Béo phì - Gút - Tăng huyết áp"
  },
  {
    "value": "TTSK043",
    "label": "Béo phì - Gút - Đái tháo đường",
    "dbName": "Béo phì - Gút - Đái tháo đường"
  },
  {
    "value": "TTSK044",
    "label": "Béo phì - Gút - Rối loạn chuyển hóa lipit",
    "dbName": "Béo phì - Gút - Rối loạn chuyển hóa lipid/ Rối loạn chuyển hóa mỡ máu"
  },
  {
    "value": "TTSK045",
    "label": "Thiếu cân - Gút - Tăng huyết áp",
    "dbName": "Thiếu cân - Gút - Tăng huyết áp"
  },
  {
    "value": "TTSK046",
    "label": "Thiếu cân - Gút - Đái tháo đường",
    "dbName": "Thiếu cân - Gút - Đái tháo đường"
  },
  {
    "value": "TTSK047",
    "label": "Thiếu cân - Gút - Rối loạn chuyển hóa lipit",
    "dbName": "Thiếu cân - Gút - Rối loạn chuyển hóa lipid/ Rối loạn chuyển hóa mỡ máu"
  },
  {
    "value": "TTSK048",
    "label": "Gút- Tăng huyết áp - Đái tháo đường",
    "dbName": "Tăng huyết áp - Gút - Đái tháo đường"
  },
  {
    "value": "TTSK049",
    "label": "Gút - Tăng huyết áp - Rối loạn chuyển hóa lipit",
    "dbName": "Tăng huyết áp - Gút - Rối loạn chuyển hóa lipid/ Rối loạn chuyển hóa mỡ máu"
  },
  {
    "value": "TTSK050",
    "label": "Rối loạn chuyển hóa - Đái tháo đường - Gút",
    "dbName": "Đái tháo đường - Gút - Rối loạn chuyển hóa lipid/ Rối loạn chuyển hóa mỡ máu"
  },
  {
    "value": "TTSK051",
    "label": "Thiếu cân - Tăng huyết áp - Rối loạn chuyển hóa lipit - Đái tháo đường",
    "dbName": "Thiếu cân - Tăng huyết áp - Đái tháo đường - Rối loạn chuyển hóa lipid/ Rối loạn chuyển hóa mỡ máu"
  },
  {
    "value": "TTSK052",
    "label": "Thừa cân - Gút - Tăng huyết áp - Đái tháo đường",
    "dbName": "Thừa cân - Tăng huyết áp - Đái tháo đường - Gút"
  },
  {
    "value": "TTSK053",
    "label": "Thừa cân - Gút - Tăng huyết áp - Rối loạn chuyển hóa lipit",
    "dbName": "Thừa cân - Tăng huyết áp - Rối loạn chuyển hóa lipid/ Rối loạn chuyển hóa mỡ máu - Gút"
  },
  {
    "value": "TTSK054",
    "label": "Thừa cân - Rối loạn chuyển hóa - Đái tháo đường - Gút",
    "dbName": "Thừa cân - Đái tháo đường - Rối loạn chuyển hóa lipid/ Rối loạn chuyển hóa mỡ máu - Gút"
  },
  {
    "value": "TTSK055",
    "label": "Béo phì - Gút - Tăng huyết áp - Đái tháo đường",
    "dbName": "Béo phì - Tăng huyết áp - Đái tháo đường - Gút"
  },
  {
    "value": "TTSK056",
    "label": "Béo phì - Gút - Tăng huyết áp - Rối loạn chuyển hóa",
    "dbName": "Béo phì - Tăng huyết áp - Rối loạn chuyển hóa lipid/ Rối loạn chuyển hóa mỡ máu - Gút"
  },
  {
    "value": "TTSK057",
    "label": "Béo phì - Rối loạn chuyển hóa - Đái tháo đường - Gút",
    "dbName": "Béo phì - Đái tháo đường - Rối loạn chuyển hóa lipid/ Rối loạn chuyển hóa mỡ máu - Gút"
  },
  {
    "value": "TTSK058",
    "label": "Thiếu cân - Gút - Tăng huyết áp - Đái tháo đường",
    "dbName": "Thiếu cân - Tăng huyết áp - Đái tháo đường - Gút"
  },
  {
    "value": "TTSK059",
    "label": "Thiếu cân - Gút - Tăng huyết áp - Rối loạn chuyển hóa lipit",
    "dbName": "Thiếu cân - Tăng huyết áp - Rối loạn chuyển hóa lipid/ Rối loạn chuyển hóa mỡ máu - Gút"
  },
  {
    "value": "TTSK060",
    "label": "Thiếu cân - Rối loạn chuyển hóa lipit - Đái tháo đường - Gút",
    "dbName": "Thiếu cân - Đái tháo đường - Rối loạn chuyển hóa lipid/ Rối loạn chuyển hóa mỡ máu - Gút"
  },
  {
    "value": "TTSK061",
    "label": "Thừa cân - Gút - Tăng huyết áp - Rối loạn chuyển hóa lipit - Đái tháo đường",
    "dbName": "Thừa cân - Tăng huyết áp - Đái tháo đường - Rối loạn chuyển hóa lipid/ Rối loạn chuyển hóa mỡ máu - Gút"
  },
  {
    "value": "TTSK062",
    "label": "Béo phì - Gút - Tăng huyết áp - Rối loạn chuyển hóa lipit - Đái tháo đường",
    "dbName": "Béo phì - Tăng huyết áp - Đái tháo đường - Rối loạn chuyển hóa lipid/ Rối loạn chuyển hóa mỡ máu - Gút"
  },
  {
    "value": "TTSK063",
    "label": "Thiếu cân - Gút - Tăng huyết áp - Rối loạn chuyển hóa lipit - Đái tháo đường",
    "dbName": "Thiếu cân - Tăng huyết áp - Đái tháo đường - Rối loạn chuyển hóa lipid/ Rối loạn chuyển hóa mỡ máu - Gút"
  },
  {
    "value": "TTSK064",
    "label": "Gút - Tăng huyết áp - Rối loạn chuyển hóa lipit - Đái tháo đường",
    "dbName": "Tăng huyết áp - Đái tháo đường - Rối loạn chuyển hóa lipid/ Rối loạn chuyển hóa mỡ máu - Gút"
  },
  {
    "value": "NO_INFO",
    "label": "Không có thông tin",
    "dbName": "Không có thông tin"
  }
];
